import React, {Component} from 'react';
import Picture from 'Shared/Picture';

class ArticleBox extends Component {
    render() {
        const {BoxClassCss, BoxTitle, BoxImage, BoxImageAlt, BoxButtonUrl, BoxButtonText, BoxDescription, BoxButtonTarget} = this.props.box;
        return (
            <div className="article-boxes-content">
                {BoxClassCss.Value === "article-product" ? (
                    <div className={BoxClassCss.Value}>
                        <div className="article-product-content">
                            <Picture src={BoxImage.Value} alt={BoxImageAlt.Value} />
                            <div className="text">
                                <h3 dangerouslySetInnerHTML={{"__html": BoxTitle.Value }} />
                                <a className="button inverse" href={BoxButtonUrl.Value} target={BoxButtonTarget ? BoxButtonTarget : "_self"}>{BoxButtonText.Value}</a>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className={BoxClassCss.Value}>
                        <div className="article-hairstyles-content">
                            <Picture src={BoxImage.Value} alt={BoxImageAlt.Value} />
                            <div className="text">
                                <h3 dangerouslySetInnerHTML={{"__html": BoxTitle.Value }} />
                                <a className="button inverse" href={BoxButtonUrl.Value} target={BoxButtonTarget.Value ? BoxButtonTarget.Value : "_self"}>{BoxButtonText.Value}</a>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        )
    }
}

export default ArticleBox;
